import { Component, Input } from '@angular/core';

import { CopyService } from '@amfam/shared/utility/shared-services';

@Component({
  selector: 'ds-about-know-your-drive',
  templateUrl: './about-know-your-drive.component.html',
  styleUrls: ['./about-know-your-drive.component.scss'],
  standalone: false
})
export class AboutKnowYourDriveComponent {
  @Input() recentAction: string;

  constructor(public copyService: CopyService) {}
}
